import { authConfig } from "../apiConfig";

export const get_email_context = async () => {
    try {
        const response = await authConfig.post(`getEmailContext`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const save_email_conext_mapping = async (data) => {
    try {
        const response = await authConfig.post(`saveEmailContextMapping`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const get_email_context_without_pagination = async () => {
    try {
        const response = await authConfig.post(`listEmailContextMappings`);
        return response.data;
    } catch (error) {
        throw error;
    }
};